import React from 'react';
import styles from './styles.module.scss';

const TrashIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path
            d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6h14zM10 11v6M14 11v6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

interface IProps {
    onClick: () => void;
    disabled?: boolean;
    title?: string;
}

const DeleteIconButton: React.FC<IProps> = ({onClick, disabled = false, title = 'Видалити'}) => (
    <button
        type={'button'}
        className={styles.deleteIconBtn}
        disabled={disabled}
        onClick={onClick}
        title={title}
        aria-label={title}
    >
        <TrashIcon/>
    </button>
);

export default DeleteIconButton;
